
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class PosSalesPromoDialog extends Serenity.EntityDialog<PosSalesPromoRow, any> {
        protected getFormKey() { return PosSalesPromoForm.formKey; }
        protected getIdProperty() { return PosSalesPromoRow.idProperty; }
        protected getLocalTextPrefix() { return PosSalesPromoRow.localTextPrefix; }
        protected getService() { return PosSalesPromoService.baseUrl; }
        protected getDeletePermission() { return PosSalesPromoRow.deletePermission; }
        protected getInsertPermission() { return PosSalesPromoRow.insertPermission; }
        protected getUpdatePermission() { return PosSalesPromoRow.updatePermission; }

        protected form = new PosSalesPromoForm(this.idPrefix);

    }
}